import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { EmptyState, ErrorState } from "@/components/empty-state";
import { ShopLogo } from "@/components/shop-logo";

export const Route = createFileRoute("/_site/shops")({
  head: () => ({
    meta: [
      { title: "Shops — NexKey.gg" },
      { name: "description", content: "Game key shops compared on NexKey.gg." },
      { property: "og:title", content: "Shops — NexKey.gg" },
      { property: "og:description", content: "Trusted game key shops." },
    ],
    links: [{ rel: "canonical", href: "/shops" }],
  }),
  component: ShopsPage,
});

function ShopsPage() {
  const shops = useQuery({ queryKey: ["shops-all"], queryFn: () => api.shops() });
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="font-display text-3xl font-bold">Shops</h1>
      <p className="mt-1 text-sm text-muted-foreground">All shops are added manually by an admin — no auto-imported sellers.</p>
      <div className="mt-6">
        {shops.isError && <ErrorState message={(shops.error as Error).message} />}
        {shops.isSuccess && shops.data.data.length === 0 && (
          <EmptyState title="No shops configured yet" description="An admin can add shops from the admin dashboard." />
        )}
        {shops.isSuccess && shops.data.data.length > 0 && (
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3">
            {shops.data.data.map((s) => (
              <a
                key={s.id}
                href={s.websiteUrl ?? "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 rounded-xl border border-border bg-card p-4 hover:border-primary"
              >
                <ShopLogo shop={s} size="md" />
                <div>
                  <div className="font-semibold">{s.name}</div>
                  {s.trustScore != null && <div className="text-xs text-muted-foreground">Trust score: {String(s.trustScore)}</div>}
                </div>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
